import Checkbox from 'components/Checkbox/Checkbox';
import React from 'react';
import { MetaType } from 'store/modules/Meta/types';

type ToggleProps = {
  object: MetaType;
  isChecked: boolean;
  onClick: Function;
  isFirmAdmin: boolean;
};

const Toggle: React.FC<ToggleProps> = ({
  object,
  isChecked,
  onClick,
  isFirmAdmin
}) => {
  return (
    <div>
      <Checkbox
        onClick={() => onClick(object.value)}
        label={object.name}
        isChecked={isChecked}
        disabled={!isFirmAdmin}
      />
    </div>
  );
};

export default Toggle;
